module.exports = __webpack_public_path__ + "img/checkMark.bc974624.svg";